module.exports = __webpack_public_path__ + "static/media/seatPremierLight.1276bce0.png";